import { dispatchToast } from "./htmx-helpers";

/**
 * Copies the listing export JSON to the clipboard.
 *
 * Wire-up: the button carries the URL and localized messages via dataset,
 * so we don't have to stringify them into an inline onclick expression.
 *
 *   <button
 *     type="button"
 *     data-export-url="..."
 *     data-success-msg="Copied"
 *     data-failed-msg="Copy failed"
 *     onclick="copyListingExport(this)">
 */
export async function copyListingExport(button: HTMLButtonElement): Promise<void> {
  if (button.disabled) return;

  const url = button.dataset.exportUrl;
  const successMsg = button.dataset.successMsg || "Copied";
  const failedMsg = button.dataset.failedMsg || "Copy failed";

  if (!url) {
    dispatchToast(failedMsg, "error");
    return;
  }

  button.disabled = true;
  try {
    const res = await fetch(url, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const text = await res.text();
    await navigator.clipboard.writeText(text);
    dispatchToast(successMsg, "success");
  } catch (err) {
    console.error("[listing-export] copy failed", err);
    dispatchToast(failedMsg, "error");
  } finally {
    button.disabled = false;
  }
}

(window as any).copyListingExport = copyListingExport;
